"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var eventsHelper_1 = require("../utils/eventsHelper");
var SidebarNav = /** @class */ (function () {
    function SidebarNav(rootElement) {
        var that = this;
        that.rootElement = rootElement;
        var menu = rootElement.querySelector('.c-sidebar-nav');
        // If menu not yet loaded then wait for items
        this.waitForAddedMenuItems({
            selector: '.c-sidebar-nav ul li',
            parent: menu,
            recursive: false,
            done: function () {
                that.menuLoaded();
            }
        });
        // Set observer for class change on list items and set height
        that.menuLoaded();
        // Click event for submenu
        eventsHelper_1.default.live('.sidebar-nav__open-submenu, .sidebar-nav__link[href=""], .sidebar-nav__link:not([href]),' +
            '.c-sidebar-nav__open-submenu, .c-sidebar-nav__link[href=""], .c-sidebar-nav__link:not([href])', eventsHelper_1.default.clickOrTouchEvent, function (event, clickedElement) {
            event.preventDefault();
            var siblings = clickedElement.closest('ul').childNodes;
            // Hide all other open siblings
            siblings.forEach(function (sibling, index) {
                var siblingElement = sibling;
                // If not  clicked element then hide sibling
                if (siblingElement && sibling != clickedElement.closest('.sidebar-nav__item, .c-sidebar-nav__item') && siblingElement.classList && siblingElement.classList.contains('is-open')) {
                    siblingElement.classList.remove('is-open');
                    // Also remove is-open on children
                    var openChildren = siblingElement.querySelectorAll('.is-open');
                    if (openChildren) {
                        openChildren.forEach(function (child) {
                            child.classList.remove('is-open');
                        });
                    }
                }
            });
            if (clickedElement) {
                // Toggle submenu
                var listItem = clickedElement.closest('.sidebar-nav__item, .c-sidebar-nav__item');
                if (listItem.classList.contains('is-open')) {
                    listItem.classList.remove('is-open');
                    // Also remove is-open on children
                    var openChildren = listItem.querySelectorAll('.is-open');
                    if (openChildren) {
                        openChildren.forEach(function (child) {
                            child.classList.remove('is-open');
                        });
                    }
                }
                else {
                    listItem.classList.add('is-open');
                }
            }
            return false;
        }, rootElement);
    }
    SidebarNav.prototype.menuLoaded = function () {
        var that = this;
        var menus = that.rootElement.querySelectorAll('.c-sidebar-nav ul');
        menus.forEach(function (menu) {
            that.setMenuHeight(menu, true);
            //After list items has rendered check if class is changed then regenerate height
            var observer = new MutationObserver(function (event) {
                menus.forEach(function (menu) {
                    that.setMenuHeight(menu, true);
                });
            });
            // Observe list items if is-open is set
            menu.querySelectorAll('li').forEach(function (listItem) {
                observer.observe(listItem, {
                    attributes: true,
                    attributeFilter: ['class'],
                    childList: false,
                    characterData: false
                });
            });
        });
    };
    SidebarNav.prototype.waitForAddedMenuItems = function (params) {
        var that = this;
        new MutationObserver(function (mutations) {
            var el = that.rootElement.querySelectorAll(params.selector);
            if (el) {
                this.disconnect();
                params.done();
            }
        }).observe(params.parent || document, {
            subtree: !!params.recursive || !params.parent,
            childList: true,
        });
    };
    SidebarNav.prototype.setMenuHeight = function (submenu, isOpen) {
        if (submenu !== null) {
            var menuItems = submenu.parentElement.querySelectorAll('.is-open > ul > li');
            if (submenu.parentElement.classList.contains('c-sidebar-nav')) {
                menuItems = Array.from(submenu.children).concat(Array.from(menuItems));
            }
            if (menuItems.length) {
                var menuItemHeight = 50;
                var menuItemLength = menuItems.length;
                var menuHeight = menuItemHeight * menuItemLength;
                if (isOpen) {
                    submenu.style.height = menuHeight + 'px';
                }
                else {
                    submenu.style.height = 0;
                }
            }
            else {
                submenu.style.height = 0;
            }
            // Also change parent heights
            var parentChildMenu = submenu.parentElement.closest('ul');
            if (parentChildMenu) {
                this.setMenuHeight(parentChildMenu, (parentChildMenu.parentElement.classList.contains('is-open') || parentChildMenu.parentElement.classList.contains('c-sidebar-nav')));
            }
        }
    };
    return SidebarNav;
}());
exports.default = SidebarNav;
